import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { ChildTechnologyPreferenceModel } from 'src/app/models/ChildTechnologyPreferenceModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { StatusDialogboxComponent } from '../../status-dialogbox/status-dialogbox.component';
import { DeleteDialogboxComponent } from '../../delete-dialogbox/delete-dialogbox.component';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { ChildTechnologyPreferenctConstant } from 'src/app/constants/label-constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddChildTechnologyPreferenceComponent } from '../add-child-technology-preference/add-child-technology-preference.component';

@Component({
  selector: 'app-child-technology-preference',
  templateUrl: './child-technology-preference.component.html',
  styleUrls: ['./child-technology-preference.component.scss']
})
export class ChildTechnologyPreferenceComponent {
  receiptContent: any = [];
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  showData: boolean = false;
  displayedColumns: string[] = ['rowNumber', 'parentName', 'childName', 'active', 'Action'];
  dataSource: MatTableDataSource<ChildTechnologyPreferenceModel> = new MatTableDataSource();
  childTechnologyPreferenceStatusObj: any = {};
  TechnologyDeleteObj: any = {};
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  ChildTechnologyPreferenceList: any = [];
  CommonConstant: any = [];
  NoRecordFound: any = [];
  ChildTechnologyPreferenceConstant: any = [];
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.ChildTechnologyPreferenceConstant = ChildTechnologyPreferenctConstant;
    this.CommonConstant = CommonConstant
    this.NoRecordFound = NoRecordFound
    this.getChildTechnologyPreferenceList();
    this.sharedService.setData('Child Technology Preference');
  }

  getChildTechnologyPreferenceList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.ChildTechnologyPreferences.GetChildTechnologyPreferenceList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.ChildTechnologyPreferenceList = response.data
          this.dataSource.data = this.ChildTechnologyPreferenceList;
          if (this.ChildTechnologyPreferenceList.length > 0) {
            TotalRecords = this.ChildTechnologyPreferenceList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  handleImageError(event: any) {
    event.target.src = '../../../assets/img/default_college.png';
    // Replace with the path to your placeholder image
    event.onerror = null;
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getChildTechnologyPreferenceList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getChildTechnologyPreferenceList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getChildTechnologyPreferenceList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getChildTechnologyPreferenceList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getChildTechnologyPreferenceList();
    this.searchClose = false;
  }

  AddTechnology(childTechnologyPreferenceId: number) {
    const modalRef = this.modalService.open(AddChildTechnologyPreferenceComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.ChildTechnologyPreferenceId = childTechnologyPreferenceId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getChildTechnologyPreferenceList();
      }
    }).catch((error) => {
    });
  }

  Deletepopup(childTechnologyPreferenceId: number, name: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.TechnologyDeleteObj = {
      childTechnlogyPreferenceId: childTechnologyPreferenceId,
      childTechnlogyPreferencename: name,
      element: 'child technlogy preference'
    }
    modalRef.componentInstance.TechnologyDeleteObj = this.TechnologyDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getChildTechnologyPreferenceList();
      }
    }).catch((error) => {
    });
  }

  onStatus(childTechnologyPreferenceId: number, childName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.childTechnologyPreferenceStatusObj = {
      ChildTechnologyPreferenceId: childTechnologyPreferenceId,
      ChildTechnologyPreferenceName: childName,
      activeTechnology: active
    }
    modalRef.componentInstance.childTechnologyPreferenceStatusObj = this.childTechnologyPreferenceStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.ChildTechnologyPreferenceList.forEach((element: { childTechnologyPreferenceId: number; active: boolean; }) => {
          if (element.childTechnologyPreferenceId == childTechnologyPreferenceId) {
            element.active = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }
}